import React, { useEffect, useState } from 'react';
import App1 from './measurit/app1';
import BBAdmin from './BBAdmin/BBAdminRouting';
import HtmlApp from './HtmlApp';
import Measurit_v3 from './Measurit_v3.0/App_M_3.0';
import Consumer_app from './ConsumerApp/Consumer_app';
import Supplier from './Supplier/App';
import App from './Manufacturer/ManRouting';
import Visitor from './visitotApp/visitorRouting';
import './App.css';
import DeliveryPartner from './DeliveryPartner/App';
import {PageNotFound,ServerNotReachable,} from './ErrorPages';

//import { requestPermission, handleForegroundNotifications } from './push-notifications';

const MainApp = () => {
  const [shouldRenderApp1, setShouldRenderApp1] = useState(false);
  const [shouldRenderBBAdmin, setShouldRenderBBAdmin] = useState(false);
  const [shouldRenderHtmlApp, setShouldRenderHtmlApp] = useState(false);
  const [shouldRendermeasurit, setShouldRendermeasurit] = useState(false);
  const [shouldRenderconsumerapp, setShouldRenderconsumerapp] = useState(false);
  const [shouldRenderSupplier, setShouldRenderSupplier] = useState(false);
  const [shouldRenderManufacturer, setShouldRenderManufacturer] = useState(false);
  const [shouldRenderVisitor, setShouldRenderVisitor] = useState(false);
  const [shouldRenderDeliveryPartner, setShouldRenderDeliveryPartner] = useState(false);
  const [shouldRenderNotFound, setShouldRenderNotFound] = useState(false);
  const [shouldRenderServerError, setShouldRenderServerError] = useState(false);

  useEffect(() => {
    const path = window.location.pathname;

      // Handle shared RFQ URL
  if (path.startsWith('/rfq/')) {
    const rfqId = path.split('/rfq/')[1];
     const params = new URLSearchParams(window.location.search);
    const customerId = params.get('customer_id');
    if (rfqId) {
       const targetUrl =
        `/consumer/account/rfqs` +
        `?rfq_id=${encodeURIComponent(rfqId)}` +
        (customerId
          ? `&customer_id=${encodeURIComponent(customerId)}`
          : '');

      window.location.replace(targetUrl);
      return;
    }
  }

  // Handle Shared Bucket Checkout URL
    if (path.startsWith('/bucket-share/')) {
      const token = path.split('/bucket-share/')[1];
      if (token) {
       const targetUrl =
        `/consumer/shared-bucket` +
        `?token=${encodeURIComponent(token)}`;

      window.location.replace(targetUrl);
      return;
    }
    }

    if (path === '/') {
      setShouldRenderHtmlApp(true);
    } else if (path.startsWith('/measurit_v3.0')) {
      setShouldRendermeasurit(true);
    } else if (path.startsWith('/measurit')) {
      setShouldRenderApp1(true);
    } else if (path.startsWith('/admin')) {
      setShouldRenderBBAdmin(true);
    } else if (path.startsWith('/consumer')) {
      setShouldRenderconsumerapp(true);
    } else if (path.startsWith('/supplier')) {
      setShouldRenderSupplier(true);
    } else if (path.startsWith('/mfr')) {
      setShouldRenderManufacturer(true);
    } else if (path.startsWith('/visitor')) {
      setShouldRenderVisitor(true);
    } else if (path.startsWith('/delivery')) {
      setShouldRenderDeliveryPartner(true);
    } else if (path === '/503') {
      setShouldRenderServerError(true);
    } else {
      // Unknown URL
      setShouldRenderNotFound(true);
    }
  }, []);

  const handleGoDashboard = () => {
    window.location.href = '/';
  };

  const handleDocumentation = () => {
    window.open('/docs', '_blank', 'noopener,noreferrer');
  };

  const handleRetry = () => {
    window.location.reload();
  };

  const handleCheckStatus = () => {
    window.open('/status', '_blank', 'noopener,noreferrer');
  };

  return (
    <>
      {shouldRenderApp1 && <App1 />}
      {shouldRenderBBAdmin && <BBAdmin />}
      {shouldRendermeasurit && <Measurit_v3 />}
      {shouldRenderconsumerapp && <Consumer_app />} 
      {shouldRenderSupplier && <Supplier />}
      {shouldRenderHtmlApp && <HtmlApp />}
      {shouldRenderManufacturer && <App />}
      {shouldRenderVisitor && <Visitor />}
      {shouldRenderDeliveryPartner && <DeliveryPartner />}
      {shouldRenderNotFound && (
        <PageNotFound
          onGoDashboard={handleGoDashboard}
          onDocumentation={handleDocumentation}
        />
      )}
      {shouldRenderServerError && (
        <ServerNotReachable
          onRetry={handleRetry}
          onCheckStatus={handleCheckStatus}
          retrying={false}
        />
      )}
    </>
    
  );
};

export default MainApp;
